import Vue from "vue";
import Vuex from "vuex";
// import VuexPersist from "vuex-persist";
import VuexPersistence from "vuex-persist";
import VuexSharedMutations from "vuex-shared-mutations";
import Cookies from "js-cookie";

import user from "@/store/_user";

Vue.use(Vuex);

const storageKey = process.env.VUE_APP_COOKIE;

const cookieStorage = new VuexPersistence({
  key: storageKey,
  storage: window.localStorage,
  reducer: state => ({
    user: {
      account: state.user.account,
      transaction: state.user.transaction,
      transactionEwallet: state.user.transactionEwallet,
      language: state.user.language,
      socialList: state.user.socialList,
      favList: state.user.favList,
      avatarImg: state.user.avatarImg,
      currentLevel: state.user.currentLevel,
      smarticoData: state.user.smarticoData,
      missions: state.user.missions,
      badges: state.user.badges,
      currentLevelDetails: state.user.currentLevelDetails,
      nextLevelDetails: state.user.nextLevelDetails
    }
  })
});

// const cookieStorage = new VuexPersistence({
//   key: storageKey,
//   restoreState: (key) => Cookies.getJSON(key),
//   saveState: (key, state) =>
//   Cookies.set(key, state, {
//     expires: new Date(new Date().getTime() + 12 * 60 * 60 * 1000)
//   }),
//   reducer: state => ({
//     user: {
//       account: state.user.account,
//       transaction: state.user.transaction,
//       language: state.user.language,
//       royaltyLevel: state.user.royaltyLevel
//     }
//   })
// });

const store = new Vuex.Store({
  modules: {
    user
  },
  getters: {
    language: state => {
      return state.user.language;
    },
    transferDetails: state => {
      return state.user.transferDetails;
    },
    promoDetails: state => {
      return state.user.promoDetails;
    },
    adjustmentDetails: state => {
      return state.user.adjustmentDetails
    },
    refereeCount: state => {
      return state.user.refereeCount
    },
    betHistory: state => {
      return state.user.betHistory;
    },
    slotResult: state => {
      return state.user.slotResult;
    },
    cockfightResult: state => {
      return state.user.cockfightResult;
    },
    rebateResult: state => {
      return state.user.rebateResult;
    }, 
    sbResult: state => {
      return state.user.sbResult;
    },
    livecasinoResult: state => {
      return state.user.livecasinoResult;
    },
    downlineList : state => {
      return state.user.downlineList;
    },
    betList : state => {
      return state.user.betList;
    },
    claimedTicketsList : state => {
      return state.user.claimedTicketsList;
    },
    refreshKey: state => {
      return state.user.refreshKey;
    },
    accountID: state => {
      return state.user.account.account_id;
    },
    username: state => {
      return state.user.account.full_name;
    },
    sessionToken: state => {
      return state.user.account.session_token;
    },
    currency: state => {
      return state.user.account.currency;
    },
    balance: state => {
      return state.user.balance;
    },
    gameToken: state => {
      return state.user.gameToken;
    },
    lastLoginTime: state => {
      return state.user.account.last_login_time;
    },
    contactNumber: state => {
      return state.user.account.contact_phone;
    },
    bankList: state => {
      return state.user.bankList;
    },
    isLoggedIn: state => {
      if (state.user.account.session_token) {
        return true;
      } else {
        return false;
      }
    },
    email: state => {
      return state.user.account.contact_email;
    },
    // slotSelected: state => {
    //   return state.user.slotSelected;
    // },
    bankName: state => {
      if(state.user.transaction.length > 0) {
        return state.user.transaction[0].bank_name;
      } else {
        return "";
      }
    },
    bankAccHolder: state => {
      if(state.user.transaction.length > 0) {
        return state.user.transaction[0].bank_acc_holder;
      } else {
        return "";
      }
    },
    bankAccNo: state => {
      if(state.user.transaction.length > 0) {
        return state.user.transaction[0].bank_acc_no;
      } else {
        return "";
      }
    },
    transaction: state => {
      return state.user.transaction;
    },
    transactionEwallet: state => {
      return state.user.transactionEwallet;
    },
    getSocialList: state => {
      return state.user.socialList;
    },
    getFavlist: state => {
      return state.user.favList;
    },
    getAvatar: state => {
      return state.user.avatarImg;
    },
    getCurrentLevel: state => {
      return state.user.currentLevel;
    },
    getSmarticoData: state => {
      return state.user.smarticoData;
    },
    getMissions: state => {
      return state.user.missions;
    },
    getBadges: state => {
      return state.user.badges;
    },
    // isFreeCredit: state => {
    //   if (state.user.account.is_freecredit){
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }
  },
  plugins: [
    cookieStorage.plugin,
    VuexSharedMutations({
      predicate: [
        "user/uTransferDetails",
        "user/uBetHistory",
        "user/uLivecasinoResult",
        "user/uSlotResult",
        "user/uCockfightResult",
        "user/uRebateResult",
        "user/uSbResult",
        "user/uPromoDetails",
        "user/uAdjustmentDetails",
        "user/uRefereeCount",
        "user/uDownlineList",
        "user/uBetList",
        "user/uClaimedTicketsList",
        "user/updateInbox",
        "user/update",
        "user/delete",
        "user/updateBalance",
        "user/updateBank",
        "user/updateRefreshKey",
        "user/updateLanguage",
        "user/updateSociallist",
        "user/updateFavlist",
        "user/updateAvatar",
        "user/updateCurrentLevel",
        "user/updateSmarticoData",
        "user/updateMissions",
        "user/updateBadges",
        "user/updateCurrentlvlDetails",
        "user/updateNextlvlDetails",
      ]
    })
  ]
});

export default store;
